export const normal = {
  primary: '#18A6E0',
  secondary: '#004B98',
  accent: '#61D498',
  error: '#f44336',
  warning: '#ff9800',
  info: '#d7e0dc',
  success: '#4caf50',
  base: '#06314C',
  surface: '#EBF1F8',
}
